import { createReducer, on } from '@ngrx/store';
import { Apk, ApkForm } from '@core/models';
import {
  APK_FIND_SUCCESS,
  APK_FAILURE,
  APK_UPDATE_FORM,
  APK_RESET_ERROR,
  APK_RESET,
  APK_RESET_FORM,
  APK_FIND_ALL_SUCCESS,
  APK_EDIT_MODE,
  APK_CLEAR_STATE,
  APK_UPDATE_LOADING,
  APK_UPDATE_ID,
} from '@store/actions';
import { ResponseBadRequest } from '@core/interfaces/response-bad-request';
import { transformApkData } from '@core/helpers';

export interface ApkState {
  loading: boolean;
  apkList: Apk[] | null;
  error: ResponseBadRequest | null;
  editMode: boolean;
  isEditing: boolean;
  apkForm: ApkForm | null;
  apkId: string | null;
  apk: Apk | null;
}

export const initialState: ApkState = {
  loading: false,
  apkList: null,
  error: null,
  editMode: false,
  isEditing: false,
  apkForm: null,
  apkId: null,
  apk: null,
};

export const apkReducer = createReducer(
  initialState,
  on(APK_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(APK_FIND_SUCCESS, (state, { apk }) => ({ ...state, apk: transformApkData(apk) })),
  on(APK_FIND_ALL_SUCCESS, (state, { apkList }) => ({ ...state, apkList })),
  on(APK_FAILURE, (state, { error }) => ({ ...state, error })),
  on(APK_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(APK_UPDATE_FORM, (state, { apkForm }) => ({ ...state, apkForm })),
  on(APK_UPDATE_ID, (state, { apkId }) => ({ ...state, apkId })),
  on(APK_RESET, (state) => ({ ...state, apk: null, apkId: null, apkForm: null })),
  on(APK_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(APK_RESET_FORM, (state) => ({ ...state, apkForm: null, loading: false })),
  on(APK_CLEAR_STATE, () => initialState),
);
